import { AnalyticsFreeSpinsStats,AnalyticsSummary } from "services/bonus/type"

export interface StatCardConfig {
  title: string
  value: number
  isCurrency?: boolean
}

export const getSummaryStats = (summary: AnalyticsSummary): StatCardConfig[] => [
  { title: "bonus2.analytics.totalBonuses", value: summary.totalBonuses },
  { title: "bonus2.analytics.activeBonuses", value: summary.activeBonuses },
  { title: "bonus2.analytics.playerBonuses", value: summary.totalPlayerBonuses },
  { title: "bonus2.analytics.totalIssued", value: summary.totalBonusIssued, isCurrency: true }
]

export const getWageringStats = (summary: AnalyticsSummary): StatCardConfig[] => [
  { title: "bonus2.analytics.wageringRequired", value: summary.totalWageringRequired, isCurrency: true },
  { title: "bonus2.analytics.wageringCompleted", value: summary.totalWageringCompleted, isCurrency: true },
  { title: "bonus2.analytics.totalForfeited", value: summary.totalForfeited, isCurrency: true },
  { title: "bonus2.analytics.completionRate", value: Math.round(summary.completionRate) }
]

export const getFreeSpinsStats = (freeSpinsStats: AnalyticsFreeSpinsStats): StatCardConfig[] => [
  { title: "bonus2.analytics.totalAwarded", value: freeSpinsStats.totalAwarded },
  { title: "bonus2.analytics.totalUsed", value: freeSpinsStats.totalUsed },
  { title: "bonus2.analytics.remaining", value: freeSpinsStats.totalRemaining },
  { title: "bonus2.analytics.totalWinnings", value: freeSpinsStats.totalWinnings, isCurrency: true }
]
